/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * Filename and corresponding read url for a sample in the datasource
 * @export
 * @interface DatasourceRawSamplesDataRow
 *
 */
// create custom validators for the regexes
export interface DatasourceRawSamplesDataRow {
    /**
     *
     * #type string
     * #memberof DatasourceRawSamplesDataRow
        
        
         */
    fileName: string;
    /**
     * A URL which allows anyone in possession of said URL to access the resource
     * #type string
     * #memberof DatasourceRawSamplesDataRow
        
        
         */
    readUrl: string;
}
/**
 * Check if a given object implements the DatasourceRawSamplesDataRow interface.
 */
export function instanceOfDatasourceRawSamplesDataRow(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "readUrl" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DatasourceRawSamplesDataRowTypiaAssertEquals = (input: any) => {
    return ((input: any): DatasourceRawSamplesDataRow => {
        const __is = (input: any, _exceptionable: boolean = true): input is DatasourceRawSamplesDataRow => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.fileName && "string" === typeof input.readUrl && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["fileName", "readUrl"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceRawSamplesDataRow => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("string" === typeof input.readUrl || $guard(_exceptionable, {
                    path: _path + ".readUrl",
                    expected: "string",
                    value: input.readUrl
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["fileName", "readUrl"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceRawSamplesDataRow",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceRawSamplesDataRow",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DatasourceRawSamplesDataRowTypiaAssertStringify = (input: DatasourceRawSamplesDataRow): string => {
    return ((input: any): string => { const assert = (input: any): DatasourceRawSamplesDataRow => {
        const __is = (input: any): input is DatasourceRawSamplesDataRow => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).fileName && "string" === typeof (input as any).readUrl);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceRawSamplesDataRow => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("string" === typeof input.readUrl || $guard(_exceptionable, {
                    path: _path + ".readUrl",
                    expected: "string",
                    value: input.readUrl
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceRawSamplesDataRow",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceRawSamplesDataRow",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DatasourceRawSamplesDataRow): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"fileName":${$string((input as any).fileName)},"readUrl":${$string((input as any).readUrl)}}`;
    }; return stringify(assert(input)); })(input);
};
export const DatasourceRawSamplesDataRowValidatorShape = {
    'fileName': yup.string().defined(),
    'readUrl': yup.string().defined(),
};
export const DatasourceRawSamplesDataRowValidator = yup.object().shape(DatasourceRawSamplesDataRowValidatorShape);
export const DatasourceRawSamplesDataRowStringifyShapeProperties: ObjectSchema['properties'] = {
    'fileName': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'readUrl': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const DatasourceRawSamplesDataRowStringifyShape: ObjectSchema = {
    title: 'DatasourceRawSamplesDataRow Stringifier',
    type: 'object',
    properties: {
        ...DatasourceRawSamplesDataRowStringifyShapeProperties
    },
    required: [
        'fileName',
        'readUrl',
    ],
};
export const DatasourceRawSamplesDataRowStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasourceRawSamplesDataRowStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DatasourceRawSamplesDataRowStringify: (data: DatasourceRawSamplesDataRow) => string = DatasourceRawSamplesDataRowStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DatasourceRawSamplesDataRowFromJSON(json: any): DatasourceRawSamplesDataRow {
    return DatasourceRawSamplesDataRowFromJSONTyped(json, false);
}
export function DatasourceRawSamplesDataRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasourceRawSamplesDataRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'fileName': json['fileName'],
        'readUrl': json['readUrl'],
    };
}
export function DatasourceRawSamplesDataRowToJSON(value?: DatasourceRawSamplesDataRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileName': value.fileName,
        'readUrl': value.readUrl,
    };
}
